// extracted by css-extract-rspack-plugin
export default {"wrapper":"LuuLF0cMDwiECndQ","card":"n3YjB2hurVkJIr13","buttonsGroup":"X3oGQEvyUncMxQmr","footer":"yGOVXPFbU0U4SukD"};